import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import { OrderStatusSetting } from "../../types/order";
import { useOrdersStore } from "../../stores/orders/orders-store";

const ModalOverlay = styled("div")<{ isOpen: boolean }>(({ isOpen }) => ({
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: "rgba(0, 0, 0, 0.5)",
  display: isOpen ? "flex" : "none",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000
}));

const ModalContent = styled("div")({
  background: "#F7F2EB",
  borderRadius: "4px",
  padding: "32px",
  width: "562px",
  textAlign: "center",
  fontWeight: "normal",
  color: "#333",
  boxShadow: "none",
  border: "none",
  overflow: "hidden"
});

const ModalHeading = styled("div")({
  background: "transparent",
  height: "39px",
  fontSize: "1em",
  fontWeight: "bold",
  color: "#333",
  marginBottom: "20px"
});

const ViewButtonList = styled("ul")({
  listStyle: "none",
  margin: 0,
  padding: 0
});

const ViewButton = styled("li")<{ isActive: boolean }>(({ isActive }) => ({
  color: "#fff",
  fontWeight: "bold",
  textShadow: "0 1px rgba(0,0,0,0.25)",
  borderRadius: "4px",
  padding: "12px 0",
  marginBottom: "4px",
  cursor: "pointer",
  background: isActive
    ? "linear-gradient(to bottom, #223354, #223354)"
    : "linear-gradient(to bottom, #CCC, #999)",
  border: `1px solid ${isActive ? "#356083" : "#666"}`,

  "&:last-child": {
    marginBottom: 0
  },

  "&:hover": {
    opacity: 0.9
  }
}));

interface ViewFilterModalProps {
  orderStatusSettings: OrderStatusSetting[];
  activeView: string;
  onViewChange: (viewType: string) => void;
  isOpen: boolean;
  onClose: () => void;
}

const ViewFilterModal: React.FC<ViewFilterModalProps> = ({
  orderStatusSettings,
  activeView,
  onViewChange,
  isOpen,
  onClose
}) => {
  const { setActiveView } = useOrdersStore();

  const handleViewClick = (viewType: string) => {
    setActiveView(viewType);
    onViewChange(viewType);
    onClose();
  };

  return (
    <>
      <ModalOverlay isOpen={isOpen} onClick={onClose}>
        <ModalContent onClick={(e) => e.stopPropagation()}>
          <ModalHeading>View orders by</ModalHeading>
          <ViewButtonList>
            <ViewButton
              isActive={activeView === "All"}
              onClick={() => handleViewClick("All")}
            >
              All
            </ViewButton>
            {orderStatusSettings.map((setting) => {
              const viewType = `${
                setting.SettingId
              }_${setting.SettingName.split(" ").join("")}`;
              return (
                <ViewButton
                  key={viewType}
                  isActive={activeView === viewType}
                  onClick={() => handleViewClick(viewType)}
                >
                  {setting.SettingName}
                </ViewButton>
              );
            })}
          </ViewButtonList>
        </ModalContent>
      </ModalOverlay>
    </>
  );
};

export default ViewFilterModal;
